<script>
 export let title="";
 export let text="";
</script>

<h2>{title}</h2>
<div>{@html text}</div>
